import { useUnit } from 'effector-react'
import { $historyItems, $historyTotal, getGatewayHistoryFx } from './model'

export const useGatewayHistory = () => {
  const items = useUnit($historyItems)
  const total = useUnit($historyTotal)
  const loading = useUnit(getGatewayHistoryFx.pending)

  return { items, total, loading }
}
